// export const sharedData = {
//   utmParams: "?utm_source=aboutdk_home&utm_medium=web&utm_campaign=refactor",
//   utmParamsEn: "?utm_source=aboutdk_en_home&utm_medium=web&utm_campaign=refactor",
// };

export const sharedData = {
  utmParams: "",
  utmParamsEn: "",
};
